import { map } from 'lodash';
import lookerApi from './looker-api';

const createFilter = (id, value) => ({ id, value: { value } });

const createEpisodesFilter = ({ showId, seasons }) => {
  const episodesFilter = {};
  if (showId) {
    episodesFilter.showId = createFilter('showId', showId);
  }
  if (seasons) {
    episodesFilter.season = createFilter('season', seasons);
  }
  return episodesFilter;
};

export const createEpisodeFilterOptionsLoader = ({ showId, seasons }) => {
  return async () => {
    const episodesQuery = {
      id: 'episodes',
      meta: {
        fields: ['showId', 'episodeId', 'episode', 'season', 'name']
      }
    };
    const filter = createEpisodesFilter({ showId, seasons });
    const episodes = await lookerApi.runInlineQueryStream(
      episodesQuery.id,
      episodesQuery.meta,
      filter
    );
    const episodeToOptionFormatter = ({
      episodeId,
      season,
      episode,
      name
    }) => ({
      value: episodeId,
      label: `S${season} | E${episode} ${name}`
    });
    const options = map(episodes, episodeToOptionFormatter);
    return options;
  };
};
